<template>
  <div style="background: #f2f2f6;height:calc(100vh - 60px);overflow-y:auto">
        <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>设备管理</el-breadcrumb-item>
  <el-breadcrumb-item>发货记录</el-breadcrumb-item>
</el-breadcrumb>
<el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="8">
       <el-form-item label="批次号">
        <el-input style="width:100%" v-model="where.deliverno" placeholder="" clearable></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="8">
       <el-form-item label="厂家">
        <el-select
        clearable
        filterable
                v-model="where.factorycode"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in factorys"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
  </el-form-item>
    </el-col>
    <el-col :span="8">
       <el-form-item label="板商">
        <el-select
        clearable
                v-model="where.producerid"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in producer"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.innerid"
                >
                </el-option>
              </el-select>
  </el-form-item>
    </el-col>
        <el-col :span="8">
          <el-form-item label="发货日期">
            <el-date-picker
      v-model="datevalue"
      value-format="yyyy-MM-dd"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      </el-form-item>

      </el-col>
      <el-col :span="8">
        <el-form-item label="">
      </el-form-item>
      </el-col>
    
     
       <el-col :span="8" style="text-align:right">
        <el-button size="small" type="primary" @click="searchEquipment(1)">查询</el-button>
        <el-button type="success" size="mini" onclick="download('delivertable','发货记录')">导出</el-button>
      </el-form-item>
      </el-form-item>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
        id="delivertable"
          :data="tabledata"
          ref="table"
          stripe
          border
          height="calc(100% - 237px)"

          style="font-size:12px; width: calc(100% - 60px); border-radius: 10px;margin:0 30px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }"
          class="el-table"
        >
          <el-table-column
            type="index"
            fixed
            label="序号"
            :index="indexMethod"
            width="60"
          ></el-table-column>
          <el-table-column prop="deliverno" label="批次号" >
          </el-table-column>
          <el-table-column prop="num" label="数量" >
          </el-table-column>
          <el-table-column prop="min" label="起始编号" >
          </el-table-column>
          <el-table-column prop="max" label="结束编号" >
          </el-table-column>
          <el-table-column   width="150"  label="发货厂家/板商">
             <template slot-scope="scope">
              <span>{{scope.row.name||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column   width="150"  label="备注">
             <template slot-scope="scope">
              <span>{{scope.row.remark||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column  width="150"  label="发货时间">
             <template slot-scope="scope">
              <span>{{scope.row.delivertime||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="srcaddress"  width="150"  label="操作帐号">
             <template slot-scope="scope">
              <span>{{scope.row.username||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="srcaddress"  width="150"  label="撤销">
             <template slot-scope="scope">
              <span v-if="scope.row.revert">{{scope.row.revertedby}}于{{scope.row.revertedtime}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
             <el-table-column
            column-key="opt"
            label="操作"
             width="150"
            >
            <template slot-scope="scope">
              <el-button v-if="!scope.row.revert" style="font-size:12px" type="text" @click="$router.push({name:'DeliverLog',params:{deliverno:scope.row.deliverno}})">详细</el-button>
              <el-button v-if="!scope.row.revert" style="font-size:12px" type="text" @click="revert(scope.row)">全部撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
   <el-row>

        <el-pagination
          background
          :page-sizes="[20, 50, 100, 150, 200]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:20px"
        >
        </el-pagination>

    </el-row>
  </div>

</template>

<script>
import Vue from 'vue'
let customer
export default {
  name: 'Devices',
  data () {
    return {
      tabledata: [],
      factorys: [],
      datevalue:[],
      producer:[],
      pageset: {
        size: 20,
        index: 1
      },
      totalsize: 0,
      where: {
      }
    }
  },
  mounted: function () {
    var self = this
    customer = window.localStorage.getItem('customer')
    if (customer) {
      Vue.axios
        .post('/factory/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.factorys = res.data.msgbody
          } else {
          }
        })
      Vue.axios
        .post('/producer/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.producer = res.data.msgbody
          } else {
          }
        })
      this.searchEquipment()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    searchEquipment (index) {
      if (index) {
        this.pageset.index = index
      }
      if(this.datevalue&&this.datevalue.length==2){
        this.where.startdate=this.datevalue[0]
        this.where.enddate=this.datevalue[1]
      }else{
        this.where.startdate=null
        this.where.enddate=null
      }
      this.tabledata = []
      this.checkedAll = false
      Vue.axios
        .post('/equipment/deliverno/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tabledata = res.data.msgbody
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/equipment/deliverno/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchEquipment()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchEquipment()
    },
    revert(row){
      this.$confirm('分配网关将被全部还原, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Vue.axios
        .post('/equipment/revert/batch', row)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: '撤回成功',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })

      }).catch(() => {

      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-table >>> .cell {
  padding: 0 !important;
}

.success{
  color:#67c23a
}

.danger{
  color:red
}

.info{
  color:gray
}

</style>



// WEBPACK FOOTER //
// src/components/Devices/DeliverNoLog.vue